import {Size, Type, Variant} from 'constants/UIComponentEnum';
import {FmlxButton, FmlxIcon} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import './NumericInput.scss';

function IncrementDecrementArrow({value, increment, precision, onChange, maxValue, minValue}) {
  function handleIncrement() {
    let val = parseFloat(value);

    if (Number.isNaN(val)) {
      val = 0;
    }

    val += parseFloat(increment);

    onChange(val >= maxValue ? parseFloat(maxValue).toFixed(precision) : parseFloat(val).toFixed(precision));
  }

  function handleDecrement() {
    let val = parseFloat(value);

    if (Number.isNaN(val)) {
      val = 0;
    }

    val -= parseFloat(increment);

    onChange(val <= minValue ? parseFloat(minValue).toFixed(precision) : parseFloat(val).toFixed(precision));
  }

  return (
    <div className="numeric-input-arrow">
      <FmlxButton
        onlyIcon
        icon={<FmlxIcon name="ArrowUpS" size={Size.XS} />}
        variant={Variant.PLAIN}
        type={Type.BASIC}
        size={Size.XS}
        withTooltip={false}
        onClick={(e) => {
          handleIncrement();
          e.stopPropagation();
        }}
      />
      <FmlxButton
        onlyIcon
        icon={<FmlxIcon name="ArrowDownS" size={Size.XS} />}
        variant={Variant.PLAIN}
        type={Type.BASIC}
        size={Size.XS}
        withTooltip={false}
        onClick={(e) => {
          handleDecrement();
          e.stopPropagation();
        }}
      />
    </div>
  );
}

IncrementDecrementArrow.propTypes = {
  value: PropTypes.number,
  increment: PropTypes.number,
  precision: PropTypes.number,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  onChange: PropTypes.func,
};

IncrementDecrementArrow.defaultProps = {
  value: 0,
  increment: 1,
  precision: 1,
  minValue: 0,
  maxValue: 999999,
  onChange: () => {},
};

export default IncrementDecrementArrow;
